import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2013814b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-6 mb-xl-9 position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "card-header"
}
const _hoisted_3 = { class: "row justify-content-between col-md-12 ml-0 mr-0 d-flex align-items-md-center text-center pt-3 pb-5 align-self-center align-center" }
const _hoisted_4 = { class: "text-gray-800" }
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_6 = { class: "sr-only" }
const _hoisted_7 = {
  key: 1,
  class: "fas fa-power-off fa-2x text-danger"
}
const _hoisted_8 = { class: "col-md-3 p-6" }
const _hoisted_9 = { class: "text-gray-800" }
const _hoisted_10 = { style: {"font-family":"monospace"} }
const _hoisted_11 = { class: "col-md-3 p-6" }
const _hoisted_12 = { class: "d-flex align-self-center" }
const _hoisted_13 = { class: "text-gray-800" }
const _hoisted_14 = { class: "row d-flex align-items-center justify-content-center" }
const _hoisted_15 = { class: "col-md-10" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-primary svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        x: "0",
        y: "0",
        width: "24",
        height: "24"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M3,13.5 L19,12 L3,10.5 L3,3.7732928 C3,3.70255344 3.01501031,3.63261921 3.04403925,3.56811047 C3.15735832,3.3162903 3.45336217,3.20401298 3.70518234,3.31733205 L21.9867539,11.5440392 C22.098181,11.5941815 22.1873901,11.6833905 22.2375323,11.7948177 C22.3508514,12.0466378 22.2385741,12.3426417 21.9867539,12.4559608 L3.70518234,20.6826679 C3.64067359,20.7116969 3.57073936,20.7267072 3.5,20.7267072 C3.22385763,20.7267072 3,20.5028496 3,20.2267072 L3,13.5 Z",
        fill: "#4caf50"
      })
    ])
  ])
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col-md-3 p-6" }
const _hoisted_20 = { class: "text-gray-800" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-stopwatch fa-2x" }, null, -1))
const _hoisted_22 = ["title"]
const _hoisted_23 = ["title"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-primary svg-icon-2x" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        fill: "#4caf50",
        x: "4",
        y: "11",
        width: "16",
        height: "2",
        rx: "1"
      }),
      /*#__PURE__*/_createElementVNode("rect", {
        fill: "#4caf50",
        transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) ",
        x: "4",
        y: "11",
        width: "16",
        height: "2",
        rx: "1"
      })
    ])
  ])
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_27 = { class: "card-body pt-9 pb-0" }
const _hoisted_28 = { class: "d-flex flex-wrap flex-sm-nowrap mb-6 mr-2" }
const _hoisted_29 = {
  key: 0,
  class: "symbol w-200px bg-light border border-success"
}
const _hoisted_30 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-80 me-7 mb-4" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 1,
  class: "symbol w-200px bg-light border border-info"
}
const _hoisted_33 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-80 me-7 mb-4" }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 2,
  class: "symbol w-200px bg-light border border-warning"
}
const _hoisted_36 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-80 me-7 mb-4" }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 3,
  class: "symbol w-200px bg-light border border-danger"
}
const _hoisted_39 = { class: "d-flex flex-center flex-shrink-0 bg-light rounded w-100 h-80 me-7 mb-4" }
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  class: "flex-grow-1",
  style: {"margin-left":"20px"}
}
const _hoisted_42 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_43 = { class: "d-flex flex-column" }
const _hoisted_44 = { class: "d-flex align-items-center mb-1" }
const _hoisted_45 = {
  href: "#",
  class: "text-gray-800 fs-2 fw-bolder me-3"
}
const _hoisted_46 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_47 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_48 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_50 = {
  key: 3,
  class: "badge badge-light-success"
}
const _hoisted_51 = {
  key: 4,
  class: "badge badge-light-info"
}
const _hoisted_52 = {
  key: 5,
  class: "badge badge-light-warning"
}
const _hoisted_53 = {
  key: 6,
  class: "badge badge-light-danger"
}
const _hoisted_54 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_55 = {
  key: 7,
  class: "badge badge-light-primary me-3"
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_57 = {
  key: 8,
  class: "badge badge-light-success"
}
const _hoisted_58 = ["title"]
const _hoisted_59 = {
  key: 1,
  class: "mt-3 mb-2 w-100"
}
const _hoisted_60 = {
  class: "alert alert-warning d-flex flex-column flex-sm-row align-items-start align-items-sm-center p-4 mb-0 cooldown-alert",
  role: "alert"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-hourglass-split fs-1 me-4 mb-2 mb-sm-0 text-warning" }, null, -1))
const _hoisted_62 = { class: "flex-grow-1 w-100" }
const _hoisted_63 = { class: "fs-5 fw-bold mb-3 mb-sm-2 text-dark" }
const _hoisted_64 = { class: "d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = { class: "cooldown-timer fs-2 fw-bolder me-2 text-dark" }
const _hoisted_67 = {
  class: "text-dark",
  style: {"font-size":"0.95rem","line-height":"1.5"}
}
const _hoisted_68 = { class: "d-flex flex-column flex-md-row col-md-5 align-items-md-end" }
const _hoisted_69 = { class: "col-md-10 p-6 order-2 order-md-1" }
const _hoisted_70 = {
  key: 0,
  class: "text-gray-800"
}
const _hoisted_71 = ["title"]
const _hoisted_72 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_73 = { class: "d-flex" }
const _hoisted_74 = {
  key: 1,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_75 = ["disabled"]
const _hoisted_76 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_77 = { class: "sr-only" }
const _hoisted_78 = {
  key: 1,
  class: "fas fa-clock fa-1x"
}
const _hoisted_79 = {
  key: 2,
  class: "fas fa-play fa-1x"
}
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { class: "d-flex flex-wrap justify-content-start" }
const _hoisted_82 = { class: "d-flex flex-wrap" }
const _hoisted_83 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_84 = { class: "fw-bold fs-6 text-gray-500 mb-4" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-clock-history text-success" }, null, -1))
const _hoisted_86 = { class: "d-flex align-items-center" }
const _hoisted_87 = { class: "fs-4 fw-bolder" }
const _hoisted_88 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_89 = { class: "fw-bold fs-6 text-gray-500 mb-4" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-stars text-info" }, null, -1))
const _hoisted_91 = { class: "d-flex align-items-center" }
const _hoisted_92 = {
  class: "symbol symbol-25px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": ""
}
const _hoisted_93 = ["src"]
const _hoisted_94 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_95 = {
  key: 0,
  title: "Elite Member",
  class: "bi bi-award fs-3 px-1",
  style: {"color":"white"}
}
const _hoisted_96 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-500 mb-4" }, [
  /*#__PURE__*/_createTextVNode(" First Blood "),
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-droplet text-danger" })
], -1))
const _hoisted_98 = { class: "d-flex align-items-center" }
const _hoisted_99 = {
  class: "symbol symbol-25px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": ""
}
const _hoisted_100 = ["src"]
const _hoisted_101 = {
  key: 1,
  alt: "Pic",
  src: "/media/avatars/blank.png"
}
const _hoisted_102 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_103 = {
  key: 1,
  title: "Elite Member",
  class: "bi bi-award fs-3 px-1",
  style: {"color":"white"}
}
const _hoisted_104 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_105 = {
  class: "fw-bold fs-6 text-gray-500 mb-4",
  title: "Total experience you will earn on completion"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem text-warning" }, null, -1))
const _hoisted_107 = { class: "d-flex align-items-center" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_109 = {
  class: "fs-5 fw-bolder counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "",
  "data-kt-countup-prefix": "$"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-gray-400" }, "xp", -1))
const _hoisted_111 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_112 = {
  class: "fw-bold fs-6 text-gray-500 mb-4",
  title: "Total experience you will earn on completion"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cpu text-primary" }, null, -1))
const _hoisted_114 = { class: "d-flex align-items-center" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_116 = {
  class: "fs-5 fw-bolder counted",
  "data-kt-countup": "true",
  "data-kt-countup-value": "",
  "data-kt-countup-prefix": "$"
}
const _hoisted_117 = {
  key: 0,
  class: "fab la-windows text-primary fa-1x"
}
const _hoisted_118 = {
  key: 1,
  class: "fab la-linux text-warning fa-1x"
}
const _hoisted_119 = {
  key: 2,
  class: "fab la-apple fa-1x"
}
const _hoisted_120 = {
  key: 3,
  class: "fab la-android text-success fa-1x"
}
const _hoisted_121 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_122 = { class: "text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.machine.instance && _ctx.machine.instance.is_active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "machine-card-top-btn cursor-pointer col-md-3 p-6",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.StopInstance()))
              }, [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.shutdown_instance`)), 1),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("i", _hoisted_7))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.ip_address`)), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.machine.instance.ip_address), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.send`)) + " flag", 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "flag",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.flag_input) = $event)),
                      placeholder: "hackingclub{FLAG}"
                    }, null, 512), [
                      [_vModelText, _ctx.flag_input]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("i", {
                      class: "cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitFlag()))
                    }, _hoisted_18)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.time_remaining`)), 1),
                _hoisted_21,
                _createElementVNode("b", {
                  title: _ctx.$t(`${_ctx.currentLanguage}.machine.time_remaining_machine`)
                }, " " + _toDisplayString(_ctx.countdown || "00:00:00h"), 9, _hoisted_22),
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addTime())),
                  class: "cursor-pointer",
                  title: _ctx.$t(`${_ctx.currentLanguage}.machine.add_another_1h`)
                }, _hoisted_25, 8, _hoisted_23)
              ])
            ]),
            _hoisted_26
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          (_ctx.machine.dificulty == 'easy')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    class: "mw-150px mw-lg-150px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_31)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.machine.dificulty == 'medium')
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("img", {
                    class: "mw-150px mw-lg-150px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_34)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.machine.dificulty == 'hard')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("img", {
                    class: "mw-150px mw-lg-150px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_37)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.machine.dificulty == 'insane')
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("img", {
                    class: "mw-150px mw-lg-150px floating",
                    src: _ctx.machine.photo_path,
                    alt: "image"
                  }, null, 8, _hoisted_40)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("a", _hoisted_45, _toDisplayString(_ctx.machine.name), 1),
                  (
                    _ctx.machine.completion_percentage > 0 &&
                    _ctx.machine.completion_percentage < 100
                  )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.in_progress`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.completion_percentage == 100)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.completed`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.completion_percentage == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.user_progress.not_started_yet`)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_49,
                  (_ctx.machine.dificulty == 'easy')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.easy`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.dificulty == 'medium')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.medium`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.dificulty == 'hard')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.hard`)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.machine.dificulty == 'insane')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.insane`)), 1))
                    : _createCommentVNode("", true),
                  _hoisted_54,
                  (_ctx.type == 'training')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_55, "training"))
                    : _createCommentVNode("", true),
                  _hoisted_56,
                  (_ctx.machine.is_freemium)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, "Free"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.type == 'training')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["d-flex flex-wrap fw-bold mb-2 fs-5 description-container", { 'description-blurred': _ctx.descriptionBlurred }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.descriptionBlurred = !_ctx.descriptionBlurred)),
                      title: _ctx.descriptionBlurred ? _ctx.$t(`${_ctx.currentLanguage}.machine.view_machine_description`) : _ctx.$t(`${_ctx.currentLanguage}.machine.hide_machine_description`)
                    }, _toDisplayString(_ctx.machine.description || ""), 11, _hoisted_58))
                  : _createCommentVNode("", true),
                (_ctx.isStartButtonDisabled && _ctx.remainingCooldownTime !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.wait_before_start`)), 1),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.formatCooldownTime(_ctx.remainingCooldownTime)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.cooldown_info`)), 1)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  (_ctx.release_countdown)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_70, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.release_in`)) + "  " + _toDisplayString(_ctx.release_countdown || "00:00:00"), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "col-md-2 icon-position order-1 order-md-2 mb-3 mb-md-0",
                  title: !_ctx.hasFeature('machines_access') && !_ctx.machine.is_freemium ? _ctx.$t(`${_ctx.currentLanguage}.machine.only_subscribers_can_start_this_machine`) : _ctx.$t(`${_ctx.currentLanguage}.machine.start_an_instance`)
                }, [
                  (!_ctx.hasFeature('machines_access') && !_ctx.machine.is_freemium)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createVNode(_component_router_link, {
                            to: { name: 'profile-billing' },
                            class: _normalizeClass([_ctx.currentLanguage == 'pt' ? 'px-6' : _ctx.currentLanguage == 'es' ? 'px-5' : 'px-4', "menu-title bg-success py-3 rounded text-white bg-hover-opacity-75"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.subscribe`)), 1)
                            ]),
                            _: 1
                          }, 8, ["class"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        ((!_ctx.machine.instance || _ctx.machine.instance.is_active == false))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleStartClick())),
                              class: _normalizeClass([
                        (!_ctx.hasFeature('machines_access') && !_ctx.machine.is_freemium) || _ctx.isStartButtonDisabled
                          ? 'btn btn-light-secondary machine-cooldown-disabled'
                          : 'btn btn-light-success',
                        _ctx.isStartButtonDisabled ? 'disabled' : ''
                      ]),
                              style: _normalizeStyle(_ctx.isStartButtonDisabled ? { cursor: 'not-allowed', opacity: '0.6' } : {}),
                              disabled: (!_ctx.hasFeature('machines_access') && !_ctx.machine.is_freemium) || _ctx.isStartButtonDisabled ? 'disabled' : 'false',
                              id: "start_instance_btn"
                            }, [
                              (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                    _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.loading`)) + "...", 1)
                                  ]))
                                : (_ctx.isStartButtonDisabled)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_78))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_79))
                            ], 14, _hoisted_75))
                          : _createCommentVNode("", true)
                      ]))
                ], 8, _hoisted_71)
              ])
            ]),
            (_ctx.type == 'training')
              ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machine.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: tag,
                      class: "badge badge-light-dark me-3 mb-3"
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.release_date`)) + " ", 1),
                    _hoisted_85
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.moment
                        .utc(_ctx.machine.release_at)
                        .format("DD MMMM, YYYY")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.creator`)) + " ", 1),
                    _hoisted_90
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      (_ctx.machine.creator)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            alt: "Pic",
                            src: _ctx.machine.creator.avatar || '/media/avatars/blank.png'
                        
                          }, null, 8, _hoisted_93))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_94,
                    _createVNode(_component_router_link, {
                      to: { name: 'profile-user', params: { id: _ctx.machine.creator.id } },
                      class: "fs-5 fw-bolder counted",
                      "data-kt-countup": "true",
                      "data-kt-countup-value": "15000",
                      "data-kt-countup-prefix": "$"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.machine.creator.nick || 'No nick'), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    (_ctx.machine.creator.is_elite)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_95))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _hoisted_97,
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      (_ctx.machine.first_blood)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            alt: "Pic",
                            src: _ctx.machine.first_blood.avatar ||
                        '/media/avatars/blank.png'
                        
                          }, null, 8, _hoisted_100))
                        : (_openBlock(), _createElementBlock("img", _hoisted_101))
                    ]),
                    _hoisted_102,
                    (_ctx.machine.first_blood)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'profile-user', params: { id: _ctx.machine.first_blood.id } },
                          class: "fs-5 fw-bolder counted",
                          "data-kt-countup": "true",
                          "data-kt-countup-value": "15000",
                          "data-kt-countup-prefix": "$"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.machine.first_blood.nick || 'No nick'), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.machine.first_blood?.is_elite)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_103))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createTextVNode(" Total " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.of`)) + " XP ", 1),
                    _hoisted_106
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _hoisted_108,
                    _createElementVNode("div", _hoisted_109, [
                      _createTextVNode(_toDisplayString(_ctx.machine.xp) + " ", 1),
                      _hoisted_110
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("div", _hoisted_112, [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.operacional_system`)) + " ", 1),
                    _hoisted_113
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("div", _hoisted_116, [
                      (_ctx.machine.os_name == 'windows')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_117))
                        : _createCommentVNode("", true),
                      (_ctx.machine.os_name == 'linux')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_118))
                        : _createCommentVNode("", true),
                      (_ctx.machine.os_name == 'osx')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_119))
                        : _createCommentVNode("", true),
                      (_ctx.machine.os_name == 'androiud')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_120))
                        : _createCommentVNode("", true),
                      _hoisted_121,
                      _createElementVNode("small", _hoisted_122, _toDisplayString(_ctx.machine.os_name), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}